import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { canUserPreviewDocumentQuery } from 'app/edozvola/document-preview/service/document-preview.queries';
import { IRootState, useAppSelector } from 'app/config/store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'edozvola-frontend-lib/dist/ui';
import { LOCAL_STORAGE_KEYS, SESSION_STORAGE_KEYS } from 'app/shared/util/local-storage-keys';
import axios from 'axios';
import { useKeycloak } from 'app/modules/keycloak/keycloak';
import { AUTHORITIES } from 'app/config/constants';
import '../cases/cases.scss'

const DocumentPreview = () => {
  const {uuid: documentUuid} = useParams<{uuid: string}>()
  const {documentType} = useParams<{documentType: string}>()
  const navigate = useNavigate();

  const account = useAppSelector((state: IRootState) => state.authentication.account)
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const userAuthorities = useAppSelector(state => state.authentication.account.authorities);
  const hasAnonymousRole = userAuthorities && userAuthorities.includes(AUTHORITIES.NEPRIJAVLJENI);

  const [openedFromCaseSubmissionOrFileInspectionOrNoticeBoard, setOpenedFromCaseSubmissionOrFileInspectionOrNoticeBoard] = useState<boolean>(
    localStorage.getItem(LOCAL_STORAGE_KEYS.FILE_OPENED_FROM) ?
    localStorage.getItem(LOCAL_STORAGE_KEYS.FILE_OPENED_FROM)?.includes('case-submission') ||
      localStorage.getItem(LOCAL_STORAGE_KEYS.FILE_OPENED_FROM)?.includes('notice-board') ||
      localStorage.getItem(LOCAL_STORAGE_KEYS.FILE_OPENED_FROM)?.includes('case-file-inspection') : false,
  );

  useEffect(() => {
    // redirect to NIAS login if document preview was not opened from case submission or case file inspection
    if (isAuthenticated && (!openedFromCaseSubmissionOrFileInspectionOrNoticeBoard && hasAnonymousRole) && !sessionStorage.getItem(SESSION_STORAGE_KEYS.FROM_URL)) {
      sessionStorage.setItem(SESSION_STORAGE_KEYS.FROM_URL, location.pathname);
      redirectToNias();
    }
  }, []);

  useEffect(() => {
    // In some cases upper useEffect writes url to session storage event though file preview was opened from case submission or case file inspection, this removes it so query for document permission could execute
    if (openedFromCaseSubmissionOrFileInspectionOrNoticeBoard) {
      sessionStorage.removeItem(SESSION_STORAGE_KEYS.FROM_URL);
    }
  }, [openedFromCaseSubmissionOrFileInspectionOrNoticeBoard]);

  const redirectToNias = () => {
    axios.get('api/keycloak-properties').then(response => {
      if (response.data.autoRedirectToNias === true) {
        useKeycloak()?.login({ idpHint: 'saml-nias' });
      } else {
        useKeycloak()?.login();
      }
    });

  };

  const { data: documentPreviewSignedUrl, isLoading } = canUserPreviewDocumentQuery(
    documentUuid,
    documentType,
    account,
    sessionStorage.getItem(SESSION_STORAGE_KEYS.FROM_URL),
    openedFromCaseSubmissionOrFileInspectionOrNoticeBoard
  );

  const openDocument = () => {
    location.href = `${axios.defaults.baseURL}/${documentPreviewSignedUrl}`;
  };

  return (
    <>
      {!isLoading && documentPreviewSignedUrl === '' && (
        <>
          <div className={'cases-guard-container'}>
            <FontAwesomeIcon icon={'file-shield'} className={'cases-guard-icon'} />
            <div className={'cases-guard-text'}>{'Nemate ovlaštenje vidjeti dokument!'}</div>
            <Button label={'Povratak'} size={'lg'} onClick={() => navigate('/my-cases', { replace: true })} />
          </div>
        </>
      )}
      {!isLoading && documentPreviewSignedUrl && documentPreviewSignedUrl !== '' && openDocument()}
    </>
  );
}

export default DocumentPreview
